import { Typography,Grid} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import SelectConfig from "./SelectConfig";

const ProtocolForm = ({ config, setConfig, setErrorComms, errorComms, version }) =>{
    const { t } = useTranslation();

    const handleConfChange = (e, key) =>{
        var newValue = e.target.value
        setConfig((prevConfig) => ({
            ...prevConfig,
            device_setting: {
                ...prevConfig?.device_setting,
                cpr: {
                    ...prevConfig.device_setting.cpr,
                    [key]: parseInt(newValue),
                },
            }
        }));
    }

    return (<><Grid item xs={12}>
              <Typography
                color="secondary"
                style={{
                  fontWeight: 500,
                  fontSize: 22,
                  lineHeight: "30px",
                  marginTop: 18,
                }}
              >
                {t("devices.setUp.crpTitle")}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.selectCPR1Label")}
                value={config?.device_setting?.cpr?.cpr1}
                // info={t("devices.setUp.selectCPR1Label")}
                onChange={(e) => handleConfChange(e, "cpr1") }
                kv
                values={[
                  { key: 60, value: "60 sec" },
                  { key: 120, value: "120 sec" },
                  { key: 150, value: "150 sec" },
                  { key: 180, value: "180 sec" },
                ]}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.selectCPR2Label")}
                //info={t("devices.setUp.selectCPR2Label")}
                value={config?.device_setting?.cpr?.cpr2 + " sec"}
                onChange={(e) => handleConfChange(e, "cpr2") }
                values={["60 sec", "120 sec", "150 sec", "180 sec"]}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.msg_longLabel")}
                value={config?.device_setting?.cpr?.msg_long}
                onChange={(e) => handleConfChange(e, "msg_long") }
                kv
                values={[
                  { key: 0, value: t("common.short") },
                  { key: 1, value: t("common.long") },
                ]}
              />
            </Grid></>);
};

export default ProtocolForm;